import dashboard from '../../src/assets/nav/dashboard-icon.svg';
import agent from '../../src/assets/nav/agent-icon.svg';
import task from '../../src/assets/nav/task-icon.svg';
import campaign from '../../src/assets/nav/campaign-icon.svg';
import unibox from '../../src/assets/nav/unibox-icon.svg';
import email from '../../src/assets/nav/email-account-icon.svg';
import lead from '../../src/assets/nav/lead-icon.svg';
import importJobsIcon from '../../src/assets/nav/import-jobs-icon.svg';
import pendingApprovalIcon from '../../src/assets/nav/pending-approval-icon.svg';
import team from '../../src/assets/nav/team-icon.svg';
import automation from '../../src/assets/nav/automation-icon.svg';
import contacts from '../../src/assets/nav/contacts-icon.svg';
import linkedinIcon from '../../src/assets/nav/linkedin-icon.svg';
import dummyImg from '../../src/assets/avatar-2.svg';
import mikeImg from '../../src/assets/images/mike-img.jfif';
import janImg from '../../src/assets/images/jan-img.jfif';
import samImg from '../../src/assets/images/sam-img.jpg';
import elonImg from '../../src/assets/images/elon-img.webp';
import atifImg from '../../src/assets/images/atif-img.png';
import jeffImg from '../../src/assets/images/jeff-img.jpeg';

export const NavData = [
  {
    path: 'dashboard',
    file: 'dashboard',
    img: dashboard,
    name: 'Dashboard',
  },
  // {
  //   path: 'my-agents',
  //   file: 'my-agents',
  //   img: agent,
  //   name: 'My Agents',
  // },
  {
    path: 'leads-module',
    file: 'leads-module',
    img: contacts,
    name: 'Contacts',
  },
  {
    path: 'leads-list',
    file: 'leads-list',
    img: lead,
    name: 'List Builder',
  },
  {
    path: 'import-jobs',
    file: 'import-jobs',
    img: importJobsIcon,
    name: 'Add Leads',
  },
  // {
  //   path: 'task',
  //   file: 'task',
  //   img: task,
  //   name: 'Tasks',
  // },http://localhost:3002/leads-module
  {
    path: 'campaign-manager',
    file: 'campaign-manager',
    img: campaign,
    name: 'Campaigns',
  },
  {
    path: 'pending-approvals',
    file: 'pending-approvals',
    img: pendingApprovalIcon,
    name: 'Pending Approvals',
  },
  {
    path: 'unibox',
    file: 'unibox',
    img: unibox,
    name: 'Unibox',
  },
  {
    path: 'email-accounts',
    file: 'email-accounts',
    img: email,
    name: 'Email Accounts',
  },
  {
    path: 'linkedin-accounts',
    file: 'linkedin-accounts',
    img: linkedinIcon,
    name: 'LinkedIn Accounts',
  },
  {
    path: 'teams',
    file: 'teams',
    img: team,
    name: 'Teams',
  },

  // {
  //   path: 'my-team',
  //   file: 'my-team',
  //   img: team,
  //   name: 'My Team',
  // },
];


export const voiceOption = [
  {
    label: 'Professional',
    value: 'professional',
  },
  {
    label: 'Conversational',
    value: 'conversational',
  },
  {
    label: 'Friendly',
    value: 'friendly',
  },
  {
    label: 'Formal',
    value: 'formal',
  },
  {
    label: 'Technical',
    value: 'technical',
  },
];
export const langOption = [
  {
    label: 'English',
    value: 'English',
  },
  {
    label: 'Spanish',
    value: 'Spanish',
  },
  {
    label: 'Portuguese',
    value: 'Portuguese',
  },
  {
    label: 'French',
    value: 'French',
  },
  {
    label: 'German',
    value: 'German',
  },
  {
    label: 'Italian',
    value: 'Italian',
  },
  {
    label: 'Dutch',
    value: 'Dutch',
  },
  {
    label: 'Polish',
    value: 'Polish',
  },
  {
    label: 'Turkish',
    value: 'Turkish',
  },
];
export const greetOption = [
  {
    label: 'By First Name',
    value: 'By First Name',
  },
  {
    label: 'By Last Name',
    value: 'By Last Name',
  },
];

export const emailLengthOption = [
  {
    label: '60-80',
    value: '80',
  },
  {
    label: '80-100',
    value: '100',
  },
  {
    label: '100-120',
    value: '120',
  },
  {
    label: '120-140',
    value: '140',
  },
];

export const warmupEnabledOptions = [
  {
    label: 'Yes',
    value: 'Yes',
  },
  {
    label: 'No',
    value: 'No',
  },
];

export const warmupEnabledDuration = [
  {
    label: '7',
    value: '7',
  },
  {
    label: '8',
    value: '8',
  },
  {
    label: '9',
    value: '9',
  },
  {
    label: '10',
    value: '10',
  },
  {
    label: '14',
    value: '14',
  },
  {
    label: '18',
    value: '18',
  },
  {
    label: '21',
    value: '21',
  },
];

// Country code to country name mapping
export const COUNTRY_NAMES = {
  FR: 'France',
  DE: 'Germany',
  GB: 'United Kingdom',
  US: 'United States',
  AL: 'Albania',
  DZ: 'Algeria',
  AO: 'Angola',
  AR: 'Argentina',
  AM: 'Armenia',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BO: 'Bolivia',
  BA: 'Bosnia and Herzegovina',
  BR: 'Brazil',
  BG: 'Bulgaria',
  KH: 'Cambodia',
  CA: 'Canada',
  CL: 'Chile',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CI: "Cote D'Ivoire",
  HR: 'Croatia',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  ET: 'Ethiopia',
  FI: 'Finland',
  GA: 'Gabon',
  GE: 'Georgia',
  GR: 'Greece',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IN: 'India',
  ID: 'Indonesia',
  IQ: 'Iraq',
  IE: 'Ireland',
  IL: 'Israel',
  IT: 'Italy',
  JP: 'Japan',
  KE: 'Kenya',
  MY: 'Malaysia',
  MX: 'Mexico',
  MA: 'Morocco',
  NL: 'Netherlands',
  NO: 'Norway',
  PK: 'Pakistan',
  PH: 'Philippines',
  PL: 'Poland',
  PT: 'Portugal',
  RO: 'Romania',
  RU: 'Russian Federation',
  SA: 'Saudi Arabia',
  RS: 'Serbia',
  ZA: 'South Africa',
  ES: 'Spain',
  SE: 'Sweden',
  CH: 'Switzerland',
  TH: 'Thailand',
  TR: 'Türkiye',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  UZ: 'Uzbekistan',
  VE: 'Venezuela',
  VN: 'Viet Nam',
};

export const proxyCountries = [
  { value: 'FR', label: 'France' },
  { value: 'DE', label: 'Germany' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'US', label: 'United States' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AO', label: 'Angola' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BA', label: 'Bosnia and Herzegovina' },
  { value: 'BR', label: 'Brazil' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CA', label: 'Canada' },
  { value: 'CL', label: 'Chile' },
  { value: 'CO', label: 'Colombia' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'CI', label: "Cote D'Ivoire" },
  { value: 'HR', label: 'Croatia' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czech Republic' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DO', label: 'Dominican Republic' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'FI', label: 'Finland' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GE', label: 'Georgia' },
  { value: 'GR', label: 'Greece' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JP', label: 'Japan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MX', label: 'Mexico' },
  { value: 'MA', label: 'Morocco' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NO', label: 'Norway' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russian Federation' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'RS', label: 'Serbia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'ES', label: 'Spain' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TR', label: 'Türkiye' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Viet Nam' },
];

export const languageOptions = [
  { value: "af", label: "Afrikaans" },
  { value: "sq", label: "Albanian" },
  { value: "am", label: "Amharic" },
  { value: "ar", label: "Arabic" },
  { value: "hy", label: "Armenian" },
  { value: "az", label: "Azerbaijani" },
  { value: "bn", label: "Bengali" },
  { value: "bs", label: "Bosnian" },
  { value: "bg", label: "Bulgarian" },
  { value: "fr-CA", label: "Canadian French" },
  { value: "ca", label: "Catalan" },
  { value: "zh", label: "Chinese" },
  { value: "zh-TW", label: "Chinese Traditional" },
  { value: "hr", label: "Croatian" },
  { value: "cs", label: "Czech" },
  { value: "da", label: "Danish" },
  { value: "fa-AF", label: "Dari" },
  { value: "nl", label: "Dutch" },
  { value: "en", label: "English" },
  { value: "et", label: "Estonian" },
  { value: "fi", label: "Finnish" },
  { value: "fr", label: "French" },
  { value: "ka", label: "Georgian" },
  { value: "de", label: "German" },
  { value: "el", label: "Greek" },
  { value: "gu", label: "Gujarati" },
  { value: "ht", label: "Haitian Creole" },
  { value: "ha", label: "Hausa" },
  { value: "he", label: "Hebrew" },
  { value: "hi", label: "Hindi" },
  { value: "hu", label: "Hungarian" },
  { value: "is", label: "Icelandic" },
  { value: "id", label: "Indonesian" },
  { value: "ga", label: "Irish" },
  { value: "it", label: "Italian" },
  { value: "ja", label: "Japanese" },
  { value: "kn", label: "Kannada" },
  { value: "kk", label: "Kazakh" },
  { value: "ko", label: "Korean" },
  { value: "lv", label: "Latvian" },
  { value: "lt", label: "Lithuanian" },
  { value: "mk", label: "Macedonian" },
  { value: "ms", label: "Malay" },
  { value: "ml", label: "Malayalam" },
  { value: "mt", label: "Maltese" },
  { value: "mr", label: "Marathi" },
  { value: "es-MX", label: "Mexican Spanish" },
  { value: "mn", label: "Mongolian" },
  { value: "no", label: "Norwegian" },
  { value: "ps", label: "Pashto" },
  { value: "fa", label: "Persian" },
  { value: "pl", label: "Polish" },
  { value: "pt-PT", label: "Portugal Portuguese" },
  { value: "pt", label: "Portuguese" },
  { value: "pa", label: "Punjabi" },
  { value: "ro", label: "Romanian" },
  { value: "ru", label: "Russian" },
  { value: "sr", label: "Serbian" },
  { value: "si", label: "Sinhala" },
  { value: "sk", label: "Slovak" },
  { value: "sl", label: "Slovenian" },
  { value: "so", label: "Somali" },
  { value: "es", label: "Spanish" },
  { value: "sw", label: "Swahili" },
  { value: "sv", label: "Swedish" },
  { value: "tl", label: "Tagalog" },
  { value: "ta", label: "Tamil" },
  { value: "te", label: "Telugu" },
  { value: "th", label: "Thai" },
  { value: "tr", label: "Turkish" },
  { value: "uk", label: "Ukrainian" },
  { value: "ur", label: "Urdu" },
  { value: "uz", label: "Uzbek" },
  { value: "vi", label: "Vietnamese" },
  { value: "cy", label: "Welsh" },
];

// create list modal options

export const leadStatusOptions = [
  { value: 'NEW', label: 'New' },
  { value: 'IN_CAMPAIGN', label: 'In Campaign' },
  { value: 'CAMPAIGN_DONE', label: 'Campaign Done' },
  { value: 'REPLIED', label: 'Replied' },
  { value: 'UNSUBSCRIBED', label: 'Unsubscribed' },
  { value: 'BLOCKED', label: 'Blocked' },
  { value: 'BOUNCED', label: 'Bounced' },
  { value: 'OPENED_EMAIL', label: 'Opened Email' },
  { value: 'CLICKED_LINK', label: 'Clicked Link' },
  { value: 'EMAIL_ENRICHMENT_DONE', label: 'Enrichment Done' },
];

export const contactedStatusOptions = [
  { value: 'ALL', label: 'All' },
  { value: 'CONTACTED', label: 'Contacted' },
  { value: 'UNCONTACTED_ONLY', label: 'Uncontacted Only' },
];

export const dateCreatedOptions = [
  { value: 'TODAY', label: 'Today' },
  { value: 'LAST_7_DAYS', label: 'Last 7 Days' },
  { value: 'LAST_30_DAYS', label: 'Last 30 Days' },
  { value: 'GREATER_THAN_30_DAYS', label: '> 30 Days' },
];

export const companySizeOptions = [
  { value: '1_10', label: '1-10 employees' },
  { value: '11_50', label: '11-50 employees' },
  { value: '51_200', label: '51-200 employees' },
  { value: '201_1000', label: '201-1000 employees' },
  { value: '1000_PLUS', label: '1000+ employees' },
];

export const leadSourceOptions = [
  { value: 'CSV', label: 'CSV' },
  { value: 'LINKEDIN', label: 'LinkedIn' },
];


export const sampleCsvColumns = [
  'email',
  'first_name',
  'last_name',
  'provider',
  'imap_host',
  'imap_port',
  'app_password',
  'smtp_host',
  'smtp_port',
  'use_tls',
  'use_ssl',
  'warmup_status',
  'warmup_reputation',
];

export const sampleCsvRows = [
  [
    'example1@gmail.com',
    'example',
    'example',
    'gmail',
    'imap.gmail.com',
    '993',
    'app-password-here',
    'smtp.gmail.com',
    '587',
    'true',
    'false',
    'completed',
    0,
  ],
  [
    'example2@outlook.com',
    'example',
    'example',
    'outlook',
    'outlook.office365.com',
    '993',
    'app-password-here',
    'smtp.office365.com',
    '587',
    'true',
    'false',
    'warming',
    7,
  ],
];


export const optionsFilter = [
  // { value: 'first_name', label: 'First Name' },
  // { value: 'last_name', label: 'Last Name' },
  { value: 'status', label: 'Lead Status' },
  // { value: 'lead_owner', label: 'Lead Owner' },
  { value: 'contacted_status', label: 'Contacted Status' },
  { value: 'source', label: 'Lead Source' },
  { value: 'campaigns', label: 'Campaigns' },
  { value: 'tags', label: 'Tags' },
  { value: 'list', label: 'List' },
  { value: 'date_created', label: 'Date Created' },
  { value: 'email', label: 'Email' },
  // { value: 'last_activity', label: 'Last Activity' },
  // { value: 'email_engagement', label: 'Email Engagement' },
  // { value: 'company_name', label: 'Company Name' },
  { value: 'title', label: 'Job Title' },
  { value: 'email_exists', label: 'Email Exists' },
  { value: 'person_linkedin_url', label: 'LinkedIn Profile' },
  { value: 'location', label: 'Location' },
  { value: 'industry', label: 'Industry' },
  { value: 'headline', label: 'Headline' },
  { value: 'open_to_work', label: 'Open to Work' },
  { value: 'is_hiring', label: 'Is Hiring' },
  { value: 'language', label: 'Language' },
  // { value: 'company_size', label: 'Company Size' },
  // { value: 'country', label: 'Country' },
  // { value: 'city', label: 'City' },

];

// All available operators
export const allOperators = {
  equals: { value: 'equals', label: 'Equal (==)' },
  contains: { value: 'contains', label: 'Contains' },
  startsWith: { value: 'startsWith', label: 'Starts With' },
  endsWith: { value: 'endsWith', label: 'Ends With' },
  notEquals: { value: 'notEquals', label: 'Not Equal (!=)' },
  isEmpty: { value: 'isEmpty', label: 'Is Empty' },
  isNotEmpty: { value: 'isNotEmpty', label: 'Is Not Empty' },
  isEnlist: { value: 'isEnlist', label: 'Is Enlist' },
  isNotEnlist: { value: 'isNotEnlist', label: 'Is Not Enlist' },
  isTrue: { value: 'isTrue', label: 'Is True' },
  isFalse: { value: 'isFalse', label: 'Is False' },
  exist: { value: 'exist', label: 'Exist' },
  notExist: { value: 'notExist', label: 'Not Exist' },
  notContains: { value: 'notContains', label: 'Not Contains' },
};

// Field-specific operator configuration
export const fieldOperatorConfig = {
  // Lead Status: equal / not equal
  status: [allOperators.equals, allOperators.notEquals],

  // Contact Status: equal / not equal
  contacted_status: [allOperators.equals, allOperators.notEquals],

  // Lead Source: equal / not equal
  source: [allOperators.equals, allOperators.notEquals],

  // Campaign: equal / not equal / is empty / not empty
  campaigns: [allOperators.equals, allOperators.notEquals, allOperators.isEmpty, allOperators.isNotEmpty],

  // Tags: equal / not equal / is empty / not empty
  tags: [allOperators.equals, allOperators.notEquals, allOperators.isEmpty, allOperators.isNotEmpty],

  // List: equal / not equal / is enlist / is not enlist
  list: [allOperators.equals, allOperators.notEquals, allOperators.isEnlist, allOperators.isNotEnlist],

  // Date Created: equal / not equal
  date_created: [allOperators.equals, allOperators.notEquals],

  // Company Name: equal / not equal / is empty / not empty
  company_name: [allOperators.equals, allOperators.notEquals, allOperators.isEmpty, allOperators.isNotEmpty],

  // Job Title: same operators as input filters (previous behavior)
  title: [
    allOperators.equals,
    allOperators.contains,
    allOperators.startsWith,
    allOperators.endsWith,
    allOperators.notEquals,
    allOperators.isEmpty,
    allOperators.isNotEmpty,
  ],

  // Location: same operators as Job Title
  location: [
    allOperators.equals,
    allOperators.contains,
    allOperators.startsWith,
    allOperators.endsWith,
    allOperators.notEquals,
    allOperators.isEmpty,
    allOperators.isNotEmpty,
  ],

  // Industry
  industry: [
    allOperators.equals,
    allOperators.contains,
    allOperators.notEquals,
    allOperators.isEmpty,
    allOperators.isNotEmpty,
  ],

  // Headline
  headline: [
    allOperators.contains,
    allOperators.notContains,
    allOperators.isEmpty,
    allOperators.isNotEmpty,
  ],

  // Open to Work: boolean flags
  open_to_work: [allOperators.isTrue, allOperators.isFalse],

  // Is Hiring: boolean flags
  is_hiring: [allOperators.isTrue, allOperators.isFalse],

  // Language: equals / not equals (value = language dropdown)
  language: [allOperators.equals, allOperators.notEquals],

  // LinkedIn Profile: exist / not exist
  person_linkedin_url: [allOperators.exist, allOperators.notExist],

  // Email: equal / not equal / is empty / not empty
  email: [allOperators.equals, allOperators.notEquals, allOperators.isEmpty, allOperators.isNotEmpty],

  // Email Exists: exist / not exist
  email_exists: [allOperators.exist, allOperators.notExist],
};

// Operators for input (text) fields (default for other fields)
export const optionsOperatorInput = [
  { value: 'equals', label: 'Equals (==)' },
  { value: 'contains', label: 'Contains' },
  { value: 'startsWith', label: 'Starts With' },
  { value: 'endsWith', label: 'Ends With' },
  { value: 'notEquals', label: 'Not Equals (!=)' },
  { value: 'isEmpty', label: 'Is Empty' },
  { value: 'isNotEmpty', label: 'Is Not Empty' },
];

// Operators for dropdown (select) fields (default for other select fields)
export const optionsOperatorSelect = [
  { value: 'equals', label: 'Equals (==)' },
  { value: 'notEquals', label: 'Not Equals (!=)' },
  { value: 'isEmpty', label: 'Is Empty' },
  { value: 'isNotEmpty', label: 'Is Not Empty' },
];

export const filterTypeConfig = {
  status: 'select',
  lead_owner: 'select',
  contacted_status: 'select',
  source: 'select',
  campaigns: 'select',
  tags: 'select',
  list: 'select',
  date_created: 'select',

  // These will show input
  first_name: 'input',
  last_name: 'input',
  last_activity: 'input',
  email_engagement: 'input',
  company_name: 'input',
  title: 'input',
  industry: 'input',
  location: 'input',
  headline: 'input',
  open_to_work: 'input',
  is_hiring: 'input',
  language: 'select',
  person_linkedin_url: 'input',
  email_exists: 'input',
  company_size: 'select',
  country: 'input',
  city: 'input',
};

export const dummyLeadsData = [
  {
    id: 1,
    profile_photo: mikeImg,
    first_name: 'Mike Kasher',
    custom_fields: {
      designation: 'COO',
    },
    company_name: 'Houdiny AI',
    tags: ['Sales', 'Automation'],
    email: 'mike@houdiny.ai',
    title: 'COO',
    status: 'Campaign Done',
    stage: 'Follow Up',
  },
  {
    id: 2,
    profile_photo: janImg,
    first_name: 'Jan',
    last_name: 'Kozak-Giegerich',
    company_name: 'Houdiny AI',
    tags: ['Sales', 'Automation'],
    email: 'jan@houdiny.ai',
    title: 'CEO',
  },
  {
    id: 3,
    profile_photo: samImg,
    first_name: 'Sam',
    last_name: 'Altman',
    company_name: 'Open AI',
    tags: ['AI'],
    email: 'sam@openai.com',
    title: 'CEO',
  },
  {
    id: 4,
    profile_photo: elonImg,
    first_name: 'Elon',
    last_name: 'Musk',
    company_name: 'Tesla',
    tags: ["AI", "Automotive"],
    email: 'elon@tesla.com',
    title: 'CEO',
  },
  {
    id: 5,
    profile_photo: atifImg,
    first_name: 'Muhammad',
    last_name: 'Atif',
    company_name: 'Houdiny AI',
    tags: ['Frontend Engineer'],
    email: 'atif@houdiny.ai',
    title: 'Sales Engineer',
  },
  {
    id: 5,
    profile_photo: jeffImg,
    first_name: 'Jeff',
    last_name: 'Bezos',
    company_name: 'Amazon',
    tags: ['Cloud'],
    email: 'jeff@amazon.com',
    title: 'Founder',
  },

]

export const dummyListsData = [
  {
    id: 1,
    name: 'Example List 1',
    leadCount: 1000,
    emailCount: 1000,
    campaignCount: 1,
    created_at: '2021-01-01',
    updated_at: '2021-01-01',
  },
  {
    id: 2,
    name: 'Example List 2',
    leadCount: 1000,
    emailCount: 1000,
    campaignCount: 1,
    created_at: '2021-01-01',
    updated_at: '2021-01-01',
  },
  {
    id: 3,
    name: 'Example List 3',
    leadCount: 1000,
    emailCount: 1000,
    campaignCount: 1,
    created_at: '2021-01-01',
    updated_at: '2021-01-01',
  },
  {
    id: 4,
    name: 'Example List 4',
    leadCount: 1000,
    emailCount: 1000,
    campaignCount: 1,
    created_at: '2021-01-01',
    updated_at: '2021-01-01',
  },

]

export const dummyCampaignsData = [
  {
    id: 1,
    name: 'Example Campaign 1',
    status: 'running',
    created_at: '2021-01-01',
    total_leads: 1000,
    total_replies: 200,
  },
  {
    id: 2,
    name: 'Example Campaign 2',
    status: 'running',
    created_at: '2021-01-01',
    total_leads: 1000,
    total_replies: 200,
  },
  {
    id: 3,
    name: 'Example Campaign 3',
    status: 'completed',
    created_at: '2021-01-01',
    total_leads: 1000,
    total_replies: 200,
  },
  {
    id: 4,
    name: 'Example Campaign 4',
    status: 'completed',
    created_at: '2021-01-01',
    total_leads: 1000,
    total_replies: 200,
  },

]

export const dummyThreadsData = [
  {
    id: 1,
    Lead: {
      UserLeads: {
        profile_photo: mikeImg,
        first_name: 'Mike Kasher',
      }
    },
    EmailMessages: [
      {
        body: '7 days free trial',
      }
    ],
    lastUpdated: '2021-01-01',
    // unreadMessageCount: 0,
  },
  {
    id: 2,
    Lead: {
      UserLeads: {
        profile_photo: dummyImg,
        first_name: 'Positive Reply',
      }
    },
    EmailMessages: [
      {
        body: 'Let schedule a meeting',
      }
    ],
    lastUpdated: '2021-01-01',
    unreadMessageCount: 1,
  },
  {
    id: 2,
    Lead: {
      UserLeads: {
        profile_photo: dummyImg,
        first_name: 'Positive Reply',
      }
    },
    EmailMessages: [
      {
        body: 'Let schedule a meeting',
      }
    ],
    lastUpdated: '2021-01-01',
    unreadMessageCount: 1,
  },
  {
    id: 2,
    Lead: {
      UserLeads: {
        profile_photo: dummyImg,
        first_name: 'Positive Reply',
      }
    },
    EmailMessages: [
      {
        body: 'Let schedule a meeting',
      }
    ],
    lastUpdated: '2021-01-01',
    unreadMessageCount: 1,
  },
  {
    id: 2,
    Lead: {
      UserLeads: {
        profile_photo: dummyImg,
        first_name: 'Positive Reply',
      }
    },
    EmailMessages: [
      {
        body: 'Let schedule a meeting',
      }
    ],
    lastUpdated: '2021-01-01',
    unreadMessageCount: 1,
  },
  {
    id: 2,
    Lead: {
      UserLeads: {
        profile_photo: dummyImg,
        first_name: 'Positive Reply',
      }
    },
    EmailMessages: [
      {
        body: 'Let schedule a meeting',
      }
    ],
    lastUpdated: '2021-01-01',
    unreadMessageCount: 1,
  },
  {
    id: 2,
    Lead: {
      UserLeads: {
        profile_photo: dummyImg,
        first_name: 'Positive Reply',
      }
    },
    EmailMessages: [
      {
        body: 'Let schedule a meeting',
      }
    ],
    lastUpdated: '2021-01-01',
    unreadMessageCount: 1,
  },
  {
    id: 2,
    Lead: {
      UserLeads: {
        profile_photo: dummyImg,
        first_name: 'Positive Reply',
      }
    },
    EmailMessages: [
      {
        body: 'Let schedule a meeting',
      }
    ],
    lastUpdated: '2021-01-01',
    unreadMessageCount: 1,
  },

]


export const dummyDomainsData = [
  {
    id: 1,
    name: 'Example Domain 1',
    selector: 'Example Selector 1',
    verificationStatus: 'Success',

  },
  {
    id: 2,
    name: 'Example Domain 2',
    selector: 'Example Selector 2',
    verificationStatus: 'Success',
  },
  {
    id: 3,
    name: 'Example Domain 3',
    selector: 'Example Selector 3',
    verificationStatus: 'Success',
  },

  {
    id: 4,
    name: 'Example Domain 4',
    selector: 'Example Selector 4',
    verificationStatus: 'Success',
  },
  {
    id: 5,
    name: 'Example Domain 5',
    selector: 'Example Selector 5',
    verificationStatus: 'Success',
  },
  {
    id: 6,
    name: 'Example Domain 6',
    selector: 'Example Selector 6',
    verificationStatus: 'Success',
  },
  {
    id: 7,
    name: 'Example Domain 7',
    selector: 'Example Selector 7',
    verificationStatus: 'Success',
  },
  {
    id: 8,
    name: 'Example Domain 8',
    selector: 'Example Selector 8',
    verificationStatus: 'Success',
  },
]

export const dummyJobsData = [

  {
    id: 1,
    name: 'Example 1',
    leadsCount: 1000,
    source: 'linkedin',
    created_at: '2021-01-01',
    linkedinScraped: {
      status: 'succeeded',
      progress: 100,
    },
    progress: 100,
  },
  {
    id: 1,
    name: 'Example 2',
    leadsCount: 1000,
    source: 'linkedin',
    created_at: '2021-01-01',
    linkedinScraped: {
      status: 'succeeded',
      progress: 100,
    },
    progress: 100,
  },
  {
    id: 1,
    name: 'Example 3',
    leadsCount: 1000,
    source: 'CSV',
    created_at: '2021-01-01',
    linkedinScraped: {
      status: 'succeeded',
      progress: 100,
    },
    progress: 100,
  },
  {
    id: 1,
    name: 'Example 4',
    leadsCount: 1000,
    source: 'CSV',
    created_at: '2021-01-01',
    linkedinScraped: {
      status: 'succeeded',
      progress: 100,
    },
    progress: 100,
  },

]

export const dummyEmailsData = [
  {
    id: 1,
    email: 'Example Email 1',
    warmup_status: 'warming',
    warmup_reputation: '7',
    provider: 'gmail',
    verificationStatus: 'Success',
  },
  {
    id: 2,
    email: 'Example Email 2',
    warmup_status: 'completed',
    warmup_reputation: '7',
    provider: 'outlook',
    verificationStatus: 'Success',
  },
  {
    id: 3,
    email: 'Example Email 3',
    warmup_status: 'completed',
    warmup_reputation: '7',
    provider: 'yahoo',
    verificationStatus: 'Success',
  },

  {
    id: 4,
    email: 'Example Email 4',
    warmup_status: 'completed',
    warmup_reputation: '7',
    provider: 'Example Provider',
    verificationStatus: 'Success',
  },

]

// Dummy Unibox messages for Storybook / local demos
export const dummyUniboxMessagesData = [
  {
    id: 'storybook-msg-1',
    direction: 'OUTBOUND',
    body: '<p>Hey Mike, I just signed up for the free trial of Houdiny AI!</p>',
    created_at: '2026-01-01T10:00:00Z',
    from: 'mike@houdiny.ai',
    to: 'mike@example.com',
    subject: 'Welcome to the Storybook thread',
    isRead: true,
    senderProvider: 'ses',
  },
  {
    id: 'storybook-msg-2',
    direction: 'INBOUND',
    body: '<p>Hi, ghous this is great let me know if you have any questions?</p>',
    created_at: '2026-01-01T10:05:00Z',
    from: 'mike@example.com',
    to: 'freetrial@houdiny.ai',
    subject: 'Re: Welcome to the Storybook thread',
    isRead: true,
    senderProvider: 'ses',
  },
  {
    id: 'storybook-msg-3',
    direction: 'OUTBOUND',
    body: "<p>Can you explain how the unibox works?</p>",
    created_at: '2026-01-01T10:10:00Z',
    from: 'storybook@houdiny.ai',
    to: 'john@example.com',
    subject: 'Re: Welcome to the Storybook thread',
    isRead: true,
    senderProvider: 'ses',
  },
  {
    id: 'storybook-msg-4',
    direction: 'INBOUND',
    body: "<p>Absolutely! Unibox centralizes all your email conversations in one view so you don't miss important replies.</p>",
    created_at: '2026-01-01T10:15:00Z',
    from: 'mike@example.com',
    to: 'freetrial@houdiny.ai',
    subject: 'Re: Welcome to the Storybook thread',
    isRead: true,
    senderProvider: 'ses',
  },
  {
    id: 'storybook-msg-5',
    direction: 'OUTBOUND',
    body: "<p>Thank you, I am ready to generate leads now.</p>",
    created_at: '2026-01-01T10:20:00Z',
    from: 'storybook@houdiny.ai',
    to: 'john@example.com',
    subject: 'Re: Welcome to the Storybook thread',
    isRead: true,
    senderProvider: 'ses',
  },


];

export const dummyAllMembersData = [

  {
    id: 1,
    profilePicture: dummyImg,
    email: 'john.doe@example.com',
    role: {
      name: "Sales Manager"
    },
    plan: {
      name: "Enterprise",
      status: "Active"
    },
    user: {
      fullName: 'Sam',
      lastLoginDate: '2021-01-01'
    }

  },
  {
    id: 2,
    profilePicture: dummyImg,
    email: 'john.doe@example.com',
    role: {
      name: "BDR"
    },
    plan: {
      name: "PRO",
      status: "Active"
    },
    user: {
      fullName: 'Elon',
      lastLoginDate: '2021-01-01'
    }

  },

]

export const dummyInvitedMembersData = [
  {
    id: 1,
    email: 'example@email.com',
    role: "Sales Manager",
    status: "active",
  },
  {
    id: 2,
    email: 'example@email.com',
    role: "BDR",
    status: "active",
  }
]

export const dummyPendingApprovalsData = [
  {
    id: 'tour-pending-approval-1',
    leadId: 1,
    campaignId: 1,
    currentStep: '0',
    user_lead: {
      id: 1,
      email: 'contact@example.com',
      subject_one: 'Hello Firstname',
      message_one:
        '<p>I noticed you’re juggling a stack that includes Sales Navigator, Apollo.io, Woodpecker, Expandi, and even OpenAI for prompts at Comapny Name.<br>That kind of tool mix means your reps spend more time hopping between apps than actually reaching prospects.</p>' +
        '<p><br></p>' +
        '<p>The fragmented stack forces your team to toggle between platforms, leading to lost time, data silos, and higher operational costs that hamper campaign speed.<br>Houdiny combines all outbound tools you use into a single system without extra costs, so you can keep everything in one place.</p>' +
        '<p><br></p>' +
        '<p>Our clients consistently generate an average of 40 qualified leads per month using Houdiny’s unified platform, giving them the extra pipeline they need.<br>Imagine what a similar boost could look like for Company Name.</p>' +
        '<p><br></p>' +
        '<p>Lets talk over a coffe, book a slot here: https://calendly.com/jan-kozak-giegerich-bdr/30min</p>' +
        '<p><br></p>' +
        '<p>Jan Kozak-Giegerich<br>Founder of Houdiny AI<br>www.houdiny.ai<br>Frankfurt | Dubai</p>',
    },
  },
]

export const senderBarOptions = [
  // { value: 'all', label: 'All' },
  { value: 'REPLIED', label: 'Replied' },
  { value: 'WAITING_FOR_REPLY', label: 'Outgoing' },
];

export const SPINTAX_TEMPLATES = [
  { label: 'Default', content: '{x|y|z}' },
  { label: 'Greeting', content: '{Hello|Hi|Hey}' },
  { label: 'Greeting + first name', content: '{Hello|Hi|Hey} {{first_name}},' },
  {
    label: 'Opening line',
    content: '{I wanted to reach out|Just checking in|Quick note for you}',
  },
  {
    label: 'Call to action',
    content: '{Would you be open to a quick chat|Let me know if this is relevant|Happy to share more details}',
  },
  { label: 'Sign-off', content: '{Best|Regards|Cheers}' },
  {
    label: 'Full email template',
    content:
      '<p>{Hello|Hi|Hey} {{first_name}},</p>' +
      '<p><br></p>' +
      '<p>{I wanted to reach out|Just checking in|Quick note for you} about how we can help.</p>' +
      '<p><br></p>' +
      '<p>{Would you be open to a quick chat|Let me know if this is relevant|Happy to share more details} this week.</p>' +
      '<p><br></p>' +
      '<p>Thanks,</p>' +
      '<p><br></p>' +
      '<p>{Best|Regards|Cheers}</p>',
  },
];